import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-full-1 bg-grey-50" }
const _hoisted_2 = { class: "s20 widget flex align-items-center px-1 py-5" }
const _hoisted_3 = { class: "s2_mobile h-100p px-7" }
const _hoisted_4 = { class: "rounded-100 overflow-hidden item active" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "s4_mobile h-100p px-2" }
const _hoisted_7 = { class: "s3_mobile h-100p px-2" }
const _hoisted_8 = { class: "font-normal mb-5" }
const _hoisted_9 = { class: "s4_mobile h-100p px-3" }
const _hoisted_10 = { class: "font-normal" }
const _hoisted_11 = { class: "text-2xl" }
const _hoisted_12 = { class: "s20 widget px-6 pt-8 pb-2" }
const _hoisted_13 = { class: "s20 items-center gap-6 pb-4 collapse-content active" }
const _hoisted_14 = { class: "grid4 px-1" }
const _hoisted_15 = { class: "s10" }
const _hoisted_16 = { class: "secondary-font font-semibold mb-1" }
const _hoisted_17 = { class: "secondary-font font-semibold text-grey-900 py-1" }
const _hoisted_18 = { class: "s10 text-right" }
const _hoisted_19 = {
  key: 0,
  class: "secondary-font font-semibold text-grey-600 pb-2"
}
const _hoisted_20 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_21 = {
  key: 2,
  class: "secondary-font font-semibold text-grey-600 pt-1 mb-4"
}
const _hoisted_22 = { class: "s20 widget px-6 pt-8 pb-2" }
const _hoisted_23 = { class: "s20 items-center gap-6 px-5 pb-6 collapse-content active" }
const _hoisted_24 = { class: "s20 flex gap-5" }
const _hoisted_25 = { class: "s6_mobile" }
const _hoisted_26 = { class: "card-carte" }
const _hoisted_27 = { class: "card-carte-floating" }
const _hoisted_28 = {
  key: 0,
  class: "s20"
}
const _hoisted_29 = { class: "flex align-items-center gap-2" }
const _hoisted_30 = { class: "secondary-font text-6xl" }
const _hoisted_31 = { class: "card-carte-floating-bottom" }
const _hoisted_32 = { class: "s10 secondary-font font-bold" }
const _hoisted_33 = {
  key: 1,
  class: "s20"
}
const _hoisted_34 = { class: "font-normal text-grey-500 text-center py-3" }
const _hoisted_35 = { class: "text-3xl text-grey-800" }
const _hoisted_36 = { class: "font-normal text-grey-500 text-center py-3" }
const _hoisted_37 = { class: "text-3xl text-grey-800" }
const _hoisted_38 = { class: "font-normal text-grey-500 text-center py-3" }
const _hoisted_39 = { class: "text-3xl text-grey-800" }
const _hoisted_40 = { class: "s20 collapse-content pb-7 active" }
const _hoisted_41 = { class: "s7 px-8" }
const _hoisted_42 = { class: "font-normal text-grey-500 text-center py-3" }
const _hoisted_43 = { class: "text-3xl text-grey-800" }
const _hoisted_44 = { class: "font-normal text-grey-500 text-center py-3" }
const _hoisted_45 = { class: "text-3xl text-grey-800" }
const _hoisted_46 = { class: "s7 px-8" }
const _hoisted_47 = { class: "font-normal text-grey-500 text-center py-3" }
const _hoisted_48 = { class: "text-3xl text-grey-800" }
const _hoisted_49 = { class: "font-normal text-grey-500 text-center py-3" }
const _hoisted_50 = { class: "text-3xl text-grey-800" }
const _hoisted_51 = { class: "font-normal text-grey-500 text-center py-3" }
const _hoisted_52 = { class: "text-3xl text-grey-800" }
const _hoisted_53 = { class: "text-3xl text-grey-800" }
const _hoisted_54 = {
  key: 1,
  class: "s20 widget shadow-100 px-5 py-4 text-center"
}
const _hoisted_55 = {
  key: 2,
  class: "s20 widget shadow-100 pb-1"
}
const _hoisted_56 = { class: "s20 pb-7 collapse-content active" }
const _hoisted_57 = { class: "table separator skin1 sm selection text-right" }
const _hoisted_58 = { class: "font-semibold pr-5" }
const _hoisted_59 = { class: "font-semibold text-red pr-5" }
const _hoisted_60 = { class: "font-semibold pr-5" }
const _hoisted_61 = { class: "font-semibold text-red pr-5" }
const _hoisted_62 = { class: "font-semibold text-red pr-5" }
const _hoisted_63 = { class: "font-semibold pr-5" }
const _hoisted_64 = { class: "font-semibold pr-5" }
const _hoisted_65 = { class: "text-lg font-semibold text-red pr-5" }
const _hoisted_66 = { class: "text-lg font-semibold text-red pr-5" }
const _hoisted_67 = { class: "font-semibold pr-5" }
const _hoisted_68 = { class: "font-semibold text-red pr-5" }
const _hoisted_69 = { style: {"background-color":"#e7ffd6"} }
const _hoisted_70 = { class: "font-semibold text-blue pr-5" }
const _hoisted_71 = { style: {"background-color":"#eefde3"} }
const _hoisted_72 = { class: "text-lg font-semibold text-green pr-5" }
const _hoisted_73 = {
  key: 3,
  class: "s20 widget shadow-100 px-5 py-4 text-center"
}

import { useRoute } from 'vue-router';
    import { inject, onMounted, ref } from 'vue';
import { formatAmount, formatDate, formatDateFrench } from '@/utils';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'UsersPlanView',
  setup(__props) {

    const BACKEND_URL = inject('BACKEND_URL');
    const route = useRoute();
    const user: any = route.meta.user;
    const souscription: any = route.meta.souscription;
    const prelevements = route.meta.prelevements as any[];
    const plan_mensuel: any = route.meta.plan_mensuel;
    const carte: any = route.meta.carte;
    const loading = ref(false);
    const errorMessage = ref('');

    onMounted(() => {
        console.log(plan_mensuel);
    });



return (_ctx: any,_cache: any) => {
  const _component_tempate = _resolveComponent("tempate")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[78] || (_cache[78] = _createStaticVNode("<div class=\"page-space-40\"></div><h4 class=\"s7 font-semibold px-3 pb-5\">Membre / Plan Mensuel <span class=\"text-sm text-grey-500\"></span></h4><div class=\"s13 flex-right gap-3 mt--2 mb-5 px-5\"><span class=\"btn shadow-200 white2\">Prélèvement</span><span class=\"btn shadow-200 light2 border-none\">Données financières</span><span class=\"btn shadow-200 light2 border-none\">Plan Mensuel 1</span></div>", 3)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: !!_unref(user).photo_url ? _unref(user).photo_url : '/assets/users_avatar/600w/user.jpg',
            width: "100%"
          }, null, 8, _hoisted_5)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "mb-2" }, "C788PMKJ", -1)),
        _createElementVNode("h4", null, _toDisplayString(_unref(user).nom + ' ' + _unref(user).prenom), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("h4", _hoisted_8, _toDisplayString(_unref(user).collectivite?.nom), 1),
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "tag-state warning stroke" }, "En cours", -1)),
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "tag-state notif stroke" }, "Actif", -1))
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("h4", _hoisted_10, [
          _cache[3] || (_cache[3] = _createTextVNode(" Date de fin de souscription ", -1)),
          _cache[4] || (_cache[4] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
          _createElementVNode("b", _hoisted_11, _toDisplayString(_unref(souscription) ? _unref(formatDateFrench)(_unref(souscription).date_fin) : '-'), 1)
        ])
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "s7_mobile h-100p px-5" }, [
        _createElementVNode("div", {
          class: "h-60 rounded-100 position-relative",
          style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
        }, [
          _createElementVNode("div", { class: "widget-floating py-0 text-xl flex-right" }, "Utilisation"),
          _createElementVNode("div", {
            class: "h-100p flex align-items-center justify-content-left rounded-100 text-2xl px-5 bg-pop-green",
            style: {"width":"25%"}
          }, " 25% ")
        ])
      ], -1))
    ]),
    _cache[79] || (_cache[79] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
    (_unref(souscription))
      ? (_openBlock(), _createBlock(_component_tempate, { key: 0 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "s10 mt--4 ml--4 mb-5 collapse-open active" }, [
                _createElementVNode("span", { class: "px-5 py-4 bg-color-black rounded-100 text-xl" }, [
                  _createElementVNode("img", {
                    src: "/icons/icon-panel-open.svg",
                    class: "size-xs icon-neutral mr-2 collapse-icon-open",
                    alt: ""
                  }),
                  _createElementVNode("img", {
                    src: "/icons/icon-panel-close.svg",
                    class: "size-xs icon-neutral mr-2 collapse-icon-close",
                    alt: ""
                  }),
                  _createTextVNode(" Prélèvement mensuel ")
                ])
              ], -1)),
              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "s10 mt--5-5 flex-right" }, [
                _createElementVNode("button", { class: "btn lg py-3 black active" }, [
                  _createElementVNode("img", {
                    src: "/icons/icon-pdf.svg",
                    class: "btn-icon",
                    alt: ""
                  }),
                  _createElementVNode("span", null, "Exporter en PDF")
                ]),
                _createElementVNode("button", { class: "btn lg py-3 black active" }, [
                  _createElementVNode("img", {
                    src: "/icons/icon-excel.svg",
                    class: "btn-icon",
                    alt: ""
                  }),
                  _createElementVNode("span", null, "Exporter en Excel")
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_13, [
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
                _cache[8] || (_cache[8] = _createElementVNode("div", {
                  class: "h-60 rounded-100 position-relative",
                  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
                }, [
                  _createElementVNode("div", { class: "widget-floating py-0 text-xl flex-right" }, "25%"),
                  _createElementVNode("div", {
                    class: "h-100p flex align-items-center rounded-100 px-7 bg-pop-green",
                    style: {"width":"25%"}
                  }, [
                    _createElementVNode("h2", null, "250 000 F"),
                    _createElementVNode("h2", { class: "font-medium" }, "  / 1 000 000 F")
                  ])
                ], -1)),
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
                _createElementVNode("div", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(prelevements), (prelevement, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass([{'active': prelevement.status_prelevement == 'validated'}, "widget border border-3 shadow-200 rounded-30 gap-5 px-7 py-5"]),
                      key: 'prelevement_' + index
                    }, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("h6", _hoisted_16, _toDisplayString(_unref(formatDateFrench)(prelevement.periode_prelevement)), 1),
                        _createElementVNode("h3", _hoisted_17, _toDisplayString(_unref(formatAmount)(prelevement.montant_prelevement_expected)) + " F", 1)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        (prelevement.status_prelevement == 'pending')
                          ? (_openBlock(), _createElementBlock("h5", _hoisted_19, _toDisplayString(prelevement.eta), 1))
                          : _createCommentVNode("", true),
                        (prelevement.status_prelevement == 'validated')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [...(_cache[6] || (_cache[6] = [
                              _createElementVNode("span", { class: "tag-state notif stroke" }, "Effectué", -1)
                            ]))]))
                          : _createCommentVNode("", true),
                        (prelevement.status_prelevement == 'validated')
                          ? (_openBlock(), _createElementBlock("h6", _hoisted_21, "Le 11 Déc. 2025"))
                          : _createCommentVNode("", true)
                      ])
                    ], 2))
                  }), 128))
                ]),
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "clear-both h-15" }, null, -1)),
                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "px-5 py-4 bg-color rounded-100 font-bold text-lg collapse-open active align-right" }, [
                  _createElementVNode("img", {
                    src: "/icons/icon-panel-open.svg",
                    class: "size-xs icon-neutral mr-2 collapse-icon-open",
                    alt: ""
                  }),
                  _createElementVNode("img", {
                    src: "/icons/icon-panel-close.svg",
                    class: "size-xs icon-neutral mr-2 collapse-icon-close",
                    alt: ""
                  }),
                  _createTextVNode(" Voir tous ")
                ], -1))
              ])
            ]),
            _cache[51] || (_cache[51] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
            _cache[52] || (_cache[52] = _createElementVNode("div", { class: "step vertical bg-grey-500 ml-auto mr-auto" }, null, -1)),
            _cache[53] || (_cache[53] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
            _createElementVNode("div", _hoisted_22, [
              _cache[48] || (_cache[48] = _createElementVNode("div", { class: "s10 mt--4 ml--4 mb-5 collapse-open active" }, [
                _createElementVNode("span", { class: "px-5 py-4 bg-color-black rounded-100 text-xl" }, [
                  _createElementVNode("img", {
                    src: "/icons/icon-panel-open.svg",
                    class: "size-xs icon-neutral mr-2 collapse-icon-open",
                    alt: ""
                  }),
                  _createElementVNode("img", {
                    src: "/icons/icon-panel-close.svg",
                    class: "size-xs icon-neutral mr-2 collapse-icon-close",
                    alt: ""
                  }),
                  _createTextVNode(" Données financières ")
                ])
              ], -1)),
              _cache[49] || (_cache[49] = _createElementVNode("div", { class: "s10 mt--5-5 flex-right gap-3" }, null, -1)),
              _cache[50] || (_cache[50] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        (_unref(carte))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              _cache[18] || (_cache[18] = _createElementVNode("h5", { class: "secondary-font font-bold mb-3" }, "Solde utilisable", -1)),
                              _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("h1", _hoisted_30, _toDisplayString(_unref(formatAmount)(_unref(carte).solde)), 1),
                                _cache[15] || (_cache[15] = _createElementVNode("h2", { class: "secondary-font text-4xl mt-2" }, "F", -1)),
                                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "mt-2 ml-2" }, [
                                  _createElementVNode("img", {
                                    src: "/icons/icon-eye-off.svg",
                                    class: "size-medium icon-white"
                                  })
                                ], -1))
                              ]),
                              _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("h5", _hoisted_32, _toDisplayString(_unref(carte).numero_masque), 1),
                                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "s10 flex-right align-items-center gap-2" }, [
                                  _createElementVNode("img", {
                                    src: "/icons/icon-edit.svg",
                                    class: "size-medium icon-white"
                                  }),
                                  _createElementVNode("h5", { class: "secondary-font font-bold" }, "Commerce")
                                ], -1))
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (!_unref(carte))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [...(_cache[19] || (_cache[19] = [
                              _createElementVNode("h5", { class: "secondary-font font-bold mb-3" }, "Aucune carte disponible", -1)
                            ]))]))
                          : _createCommentVNode("", true)
                      ]),
                      _cache[20] || (_cache[20] = _createElementVNode("img", {
                        src: "/images/carte_coop_light.png",
                        class: "card-carte-img"
                      }, null, -1))
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["s7_mobile px-6", {'s7_mobile': _unref(carte), 's10_mobile': !_unref(carte)}])
                  }, [
                    _createElementVNode("h4", _hoisted_34, [
                      _cache[21] || (_cache[21] = _createTextVNode(" Salaire ", -1)),
                      _cache[22] || (_cache[22] = _createElementVNode("br", { class: "mb-4" }, null, -1)),
                      _createElementVNode("b", _hoisted_35, _toDisplayString(_unref(formatAmount)(_unref(souscription).salaire)), 1)
                    ]),
                    _cache[27] || (_cache[27] = _createElementVNode("hr", null, null, -1)),
                    _createElementVNode("h4", _hoisted_36, [
                      _cache[23] || (_cache[23] = _createTextVNode(" Prélèvement sur salaire ", -1)),
                      _cache[24] || (_cache[24] = _createElementVNode("br", { class: "mb-4" }, null, -1)),
                      _createElementVNode("b", _hoisted_37, _toDisplayString(_unref(souscription).prelevement_pourcent) + "%", 1)
                    ]),
                    _cache[28] || (_cache[28] = _createElementVNode("hr", null, null, -1)),
                    _createElementVNode("h4", _hoisted_38, [
                      _cache[25] || (_cache[25] = _createTextVNode(" Prêt en Concession", -1)),
                      _cache[26] || (_cache[26] = _createElementVNode("br", { class: "mb-4" }, null, -1)),
                      _createElementVNode("b", _hoisted_39, _toDisplayString(_unref(formatAmount)(_unref(souscription).pret_concession)), 1)
                    ]),
                    _cache[29] || (_cache[29] = _createElementVNode("hr", null, null, -1))
                  ], 2),
                  _cache[30] || (_cache[30] = _createElementVNode("div", { class: "s7_mobile px-6" }, [
                    _createElementVNode("h4", { class: "font-normal text-grey-500 text-center py-3" }, [
                      _createTextVNode(" Quote Sessible"),
                      _createElementVNode("br", { class: "mb-4" }),
                      _createElementVNode("b", { class: "text-3xl text-grey-800" }, "20%")
                    ]),
                    _createElementVNode("hr"),
                    _createElementVNode("h4", { class: "font-normal text-grey-500 text-center py-3" }, [
                      _createTextVNode(" Prelevement Solde operée"),
                      _createElementVNode("br", { class: "mb-4" }),
                      _createElementVNode("b", { class: "text-3xl text-grey-800" }, "64.190 F CFA")
                    ]),
                    _createElementVNode("hr"),
                    _createElementVNode("h4", { class: "font-normal text-grey-500 text-center py-3" }, [
                      _createTextVNode(" Prel. Solde % sur Salaire"),
                      _createElementVNode("br", { class: "mb-4" }),
                      _createElementVNode("b", { class: "text-3xl text-grey-800" }, "20%")
                    ]),
                    _createElementVNode("hr")
                  ], -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _cache[47] || (_cache[47] = _createElementVNode("div", { class: "s6 px-8" }, [
                  _createElementVNode("h4", { class: "font-normal text-grey-500 text-center py-3" }, [
                    _createTextVNode(" Taux Interets Microfinance"),
                    _createElementVNode("br", { class: "mb-4" }),
                    _createElementVNode("b", { class: "text-3xl text-grey-800" }, "8,5%")
                  ]),
                  _createElementVNode("hr"),
                  _createElementVNode("h4", { class: "font-normal text-grey-500 text-center py-3" }, [
                    _createTextVNode(" Pret à Remburser apres 3 Ans:"),
                    _createElementVNode("br", { class: "mb-4" }),
                    _createElementVNode("b", { class: "text-3xl text-grey-800" }, "2.310.840 F CFA")
                  ]),
                  _createElementVNode("hr"),
                  _createElementVNode("h4", { class: "font-normal text-grey-500 text-center py-3" }, [
                    _createTextVNode(" Cash-Back TVA Attendu"),
                    _createElementVNode("br", { class: "mb-4" }),
                    _createElementVNode("b", { class: "text-3xl text-grey-800" }, "360.000 F CFA")
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("h4", _hoisted_42, [
                    _cache[31] || (_cache[31] = _createTextVNode(" Prélèvement à la Solde", -1)),
                    _cache[32] || (_cache[32] = _createElementVNode("br", { class: "mb-4" }, null, -1)),
                    _createElementVNode("b", _hoisted_43, _toDisplayString(_unref(formatAmount)(_unref(souscription).prelevement_solde)), 1)
                  ]),
                  _cache[35] || (_cache[35] = _createElementVNode("hr", null, null, -1)),
                  _createElementVNode("h4", _hoisted_44, [
                    _cache[33] || (_cache[33] = _createTextVNode(" Pret à Rembourser", -1)),
                    _cache[34] || (_cache[34] = _createElementVNode("br", { class: "mb-4" }, null, -1)),
                    _createElementVNode("b", _hoisted_45, _toDisplayString(_unref(formatAmount)(_unref(souscription).pret_rembourser)), 1)
                  ]),
                  _cache[36] || (_cache[36] = _createElementVNode("hr", null, null, -1)),
                  _cache[37] || (_cache[37] = _createElementVNode("h4", { class: "font-normal text-grey-500 text-center py-3" }, [
                    _createTextVNode(" Ans pour la Retraite"),
                    _createElementVNode("br", { class: "mb-4" }),
                    _createElementVNode("b", { class: "text-3xl text-grey-800" }, "18 ans")
                  ], -1))
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("h4", _hoisted_47, [
                    _cache[38] || (_cache[38] = _createTextVNode(" Pouvoir Achat 1 An", -1)),
                    _cache[39] || (_cache[39] = _createElementVNode("br", { class: "mb-4" }, null, -1)),
                    _createElementVNode("b", _hoisted_48, _toDisplayString(_unref(formatAmount)(_unref(souscription).pouvoir_achat_an)), 1)
                  ]),
                  _cache[45] || (_cache[45] = _createElementVNode("hr", null, null, -1)),
                  _createElementVNode("h4", _hoisted_49, [
                    _cache[40] || (_cache[40] = _createTextVNode(" Pouvoir Achat 3 Ans", -1)),
                    _cache[41] || (_cache[41] = _createElementVNode("br", { class: "mb-4" }, null, -1)),
                    _createElementVNode("b", _hoisted_50, _toDisplayString(_unref(formatAmount)(parseFloat(_unref(souscription).pouvoir_achat_an) * 3)), 1)
                  ]),
                  _cache[46] || (_cache[46] = _createElementVNode("hr", null, null, -1)),
                  _createElementVNode("h4", _hoisted_51, [
                    _cache[42] || (_cache[42] = _createTextVNode(" Durée Financement ", -1)),
                    _cache[43] || (_cache[43] = _createElementVNode("br", { class: "mb-4" }, null, -1)),
                    _createElementVNode("b", _hoisted_52, _toDisplayString(_unref(souscription).duree_mois) + " Mois", 1),
                    _cache[44] || (_cache[44] = _createTextVNode(" - ", -1)),
                    _createElementVNode("b", _hoisted_53, _toDisplayString(parseInt((parseInt(_unref(souscription).duree_mois) / 12).toString())) + " ans", 1)
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!_unref(plan_mensuel).data)
      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [...(_cache[54] || (_cache[54] = [
          _createElementVNode("span", { class: "font-semibold text-xl" }, " Aucune données financières disponibles ", -1)
        ]))]))
      : _createCommentVNode("", true),
    _cache[80] || (_cache[80] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _cache[81] || (_cache[81] = _createElementVNode("div", { class: "step vertical bg-grey-500 ml-auto mr-auto" }, null, -1)),
    _cache[82] || (_cache[82] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    (_unref(plan_mensuel).data)
      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
          _cache[76] || (_cache[76] = _createElementVNode("div", { class: "mt-6 ml-4 mb-5 collapse-open active" }, [
            _createElementVNode("span", { class: "px-5 py-4 bg-color-black rounded-100 text-xl" }, [
              _createElementVNode("img", {
                src: "/icons/icon-panel-open.svg",
                class: "size-xs icon-neutral mr-2 collapse-icon-open",
                alt: ""
              }),
              _createElementVNode("img", {
                src: "/icons/icon-panel-close.svg",
                class: "size-xs icon-neutral mr-2 collapse-icon-close",
                alt: ""
              }),
              _createTextVNode(" Plan Mensuel 1 ")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_56, [
            _cache[75] || (_cache[75] = _createStaticVNode("<div class=\"container-full-2 s20 mb-5\"><div class=\"s7\"><h4 class=\"font-semibold mt-3\">Année 1 / Janv 2026 - Déc 2026</h4></div><div class=\"s13 flex gap-2 justify-content-right\"><button class=\"btn black normal justify-content-center mx-0 btn-filtre\"><img src=\"/icons/icon-pdf.svg\" class=\"btn-icon\" alt=\"\"><span>Exporter PDF</span></button><button class=\"btn black normal justify-content-center mx-0 btn-filtre\"><img src=\"/icons/icon-excel.svg\" class=\"btn-icon\" alt=\"\"><span>Exporter Excel</span></button></div></div>", 1)),
            _createElementVNode("table", _hoisted_57, [
              _createElementVNode("thead", null, [
                _cache[57] || (_cache[57] = _createElementVNode("tr", null, [
                  _createElementVNode("th", { class: "mode text-left pl-5" }, "Mois"),
                  _createElementVNode("th", null, "1"),
                  _createElementVNode("th", null, "2"),
                  _createElementVNode("th", null, "3"),
                  _createElementVNode("th", null, "4"),
                  _createElementVNode("th", null, "5"),
                  _createElementVNode("th", null, "6"),
                  _createElementVNode("th", null, "7"),
                  _createElementVNode("th", null, "8"),
                  _createElementVNode("th", null, "9"),
                  _createElementVNode("th", null, "10"),
                  _createElementVNode("th", null, "11"),
                  _createElementVNode("th", null, "12"),
                  _createElementVNode("th", { class: "font-semibold pr-5" }, "Total")
                ], -1)),
                _createElementVNode("tr", null, [
                  _cache[55] || (_cache[55] = _createElementVNode("th", { class: "mode text-left py-5 pl-5" }, " ", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(plan_mensuel).columns, (column, index) => {
                    return (_openBlock(), _createElementBlock("th", { key: index }, _toDisplayString(column), 1))
                  }), 128)),
                  _cache[56] || (_cache[56] = _createElementVNode("th", { class: "font-semibold pr-5" }, null, -1))
                ])
              ]),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _cache[58] || (_cache[58] = _createElementVNode("td", { class: "mode text-left pl-5" }, "Décaissement", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(plan_mensuel).data['_DECAISSEMENT_'], (data, index) => {
                    return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(_unref(formatAmount)(data)), 1))
                  }), 128)),
                  _createElementVNode("td", _hoisted_58, _toDisplayString(_unref(formatAmount)(_unref(plan_mensuel)['totals']['_DECAISSEMENT_'])), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[59] || (_cache[59] = _createElementVNode("td", { class: "mode text-left pl-5" }, "25% Fond de risque", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(plan_mensuel).data['_FOND_RISQUE_'], (data, index) => {
                    return (_openBlock(), _createElementBlock("td", {
                      class: "text-red",
                      key: index
                    }, _toDisplayString(_unref(formatAmount)(data)), 1))
                  }), 128)),
                  _createElementVNode("td", _hoisted_59, _toDisplayString(_unref(formatAmount)(_unref(plan_mensuel)['totals']['_FOND_RISQUE_'])), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[60] || (_cache[60] = _createElementVNode("td", { class: "mode text-left pl-5" }, "Crédits Mensuels", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(plan_mensuel).data['_CREDITS_MENSUELS_'], (data, index) => {
                    return (_openBlock(), _createElementBlock("td", {
                      class: "",
                      key: index
                    }, _toDisplayString(_unref(formatAmount)(data)), 1))
                  }), 128)),
                  _createElementVNode("td", _hoisted_60, _toDisplayString(_unref(formatAmount)(_unref(plan_mensuel)['totals']['_CREDITS_MENSUELS_'])), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[61] || (_cache[61] = _createElementVNode("td", { class: "mode text-left pl-5" }, "Frais mensuels: 5%", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(plan_mensuel).data['_FRAIS_MENSUELS_'], (data, index) => {
                    return (_openBlock(), _createElementBlock("td", {
                      class: "text-red",
                      key: index
                    }, _toDisplayString(_unref(formatAmount)(data)), 1))
                  }), 128)),
                  _createElementVNode("td", _hoisted_61, _toDisplayString(_unref(formatAmount)(_unref(plan_mensuel)['totals']['_FRAIS_MENSUELS_'])), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[62] || (_cache[62] = _createElementVNode("td", { class: "mode text-left pl-5" }, "Renfourement: 30%", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(plan_mensuel).data['_RENFOUREMENT_'], (data, index) => {
                    return (_openBlock(), _createElementBlock("td", {
                      class: "text-red",
                      key: index
                    }, _toDisplayString(_unref(formatAmount)(data)), 1))
                  }), 128)),
                  _createElementVNode("td", _hoisted_62, _toDisplayString(_unref(formatAmount)(_unref(plan_mensuel)['totals']['_RENFOUREMENT_'])), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[63] || (_cache[63] = _createElementVNode("td", { class: "mode text-left pl-5" }, "Revolving Recharge", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(plan_mensuel).data['_REVOLVING_'], (data, index) => {
                    return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(_unref(formatAmount)(data)), 1))
                  }), 128)),
                  _createElementVNode("td", _hoisted_63, _toDisplayString(_unref(formatAmount)(_unref(plan_mensuel)['totals']['_REVOLVING_'])), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[64] || (_cache[64] = _createElementVNode("td", { class: "mode text-left pl-5" }, "Cash-Back TVA", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(plan_mensuel).data['_CASHBACK_TVA_'], (data, index) => {
                    return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(_unref(formatAmount)(data)), 1))
                  }), 128)),
                  _createElementVNode("td", _hoisted_64, _toDisplayString(_unref(formatAmount)(_unref(plan_mensuel)['totals']['_CASHBACK_TVA_'])), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[65] || (_cache[65] = _createElementVNode("td", { class: "text-lg font-semibold py-5 text-left pl-5" }, "Utilisation", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(plan_mensuel).data['_UTILISATION_'], (data, index) => {
                    return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(_unref(formatAmount)(data)), 1))
                  }), 128)),
                  _createElementVNode("td", _hoisted_65, _toDisplayString(_unref(formatAmount)(_unref(plan_mensuel)['totals']['_UTILISATION_'])), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[66] || (_cache[66] = _createElementVNode("td", { class: "font-bold text-left pl-5" }, "Index Utilisation", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(plan_mensuel).data['_UTILISATION_INDEX_'], (data, index) => {
                    return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(_unref(formatAmount)(data)), 1))
                  }), 128)),
                  _createElementVNode("td", _hoisted_66, _toDisplayString(_unref(formatAmount)(_unref(plan_mensuel)['totals']['_UTILISATION_INDEX_'])), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[67] || (_cache[67] = _createElementVNode("td", { class: "font-bold text-left pl-5" }, "Index Cumulé", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(plan_mensuel).data['_UTILISATION_CUMUL_'], (data, index) => {
                    return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(_unref(formatAmount)(data)), 1))
                  }), 128)),
                  _createElementVNode("td", _hoisted_67, _toDisplayString(_unref(formatAmount)(_unref(plan_mensuel)['totals']['_UTILISATION_CUMUL_'])), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[68] || (_cache[68] = _createElementVNode("td", { class: "mode text-left pl-5" }, "Depenses Mensuels", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(plan_mensuel).data['_DEPENSES_MENSUELS_'], (data, index) => {
                    return (_openBlock(), _createElementBlock("td", {
                      class: "text-red",
                      key: index
                    }, _toDisplayString(_unref(formatAmount)(data)), 1))
                  }), 128)),
                  _createElementVNode("td", _hoisted_68, _toDisplayString(_unref(formatAmount)(_unref(plan_mensuel)['totals']['_DEPENSES_MENSUELS_'])), 1)
                ]),
                _createElementVNode("tr", _hoisted_69, [
                  _cache[69] || (_cache[69] = _createElementVNode("td", { class: "font-semibold text-blue text-left py-4 pl-5" }, "Crédit Epargne", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(plan_mensuel).data['_CREDIT_EPARGNE_'], (data, index) => {
                    return (_openBlock(), _createElementBlock("td", {
                      class: "font-semibold text-blue",
                      key: index
                    }, _toDisplayString(_unref(formatAmount)(data)), 1))
                  }), 128)),
                  _createElementVNode("td", _hoisted_70, _toDisplayString(_unref(formatAmount)(_unref(plan_mensuel)['totals']['_CREDIT_EPARGNE_'])), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[70] || (_cache[70] = _createElementVNode("td", { class: "font-semibold text-left py-5 pl-5" }, "Solde Total Cash Flow", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(plan_mensuel).data['_SOLDE_TOTAL_CASHFLOW_'], (data, index) => {
                    return (_openBlock(), _createElementBlock("td", {
                      class: "font-semibold",
                      key: index
                    }, _toDisplayString(_unref(formatAmount)(data)), 1))
                  }), 128)),
                  _cache[71] || (_cache[71] = _createElementVNode("td", { class: "font-semibold pr-5" }, null, -1))
                ]),
                _createElementVNode("tr", _hoisted_71, [
                  _cache[72] || (_cache[72] = _createElementVNode("td", { class: "text-lg font-semibold text-green text-left py-5 pl-5" }, "Utilisation By Index", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(plan_mensuel).data['_UTILISATION_BY_INDEX_'], (data, index) => {
                    return (_openBlock(), _createElementBlock("td", {
                      class: "text-lg font-semibold text-green",
                      key: index
                    }, _toDisplayString(_unref(formatAmount)(data)), 1))
                  }), 128)),
                  _createElementVNode("td", _hoisted_72, _toDisplayString(_unref(formatAmount)(_unref(plan_mensuel)['totals']['_UTILISATION_BY_INDEX_'])), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[73] || (_cache[73] = _createElementVNode("td", { class: "text-lg font-semibold text-blue text-left py-5 pl-5" }, "Progressive", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(plan_mensuel).data['_PROGRESSIVE_'], (data, index) => {
                    return (_openBlock(), _createElementBlock("td", {
                      class: "text-lg font-semibold text-blue",
                      key: index
                    }, _toDisplayString(_unref(formatAmount)(data)), 1))
                  }), 128)),
                  _cache[74] || (_cache[74] = _createElementVNode("td", { class: "text-lg font-semibold text-blue pr-5" }, null, -1))
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_unref(plan_mensuel).data)
      ? (_openBlock(), _createElementBlock("div", _hoisted_73, [...(_cache[77] || (_cache[77] = [
          _createElementVNode("span", { class: "font-semibold text-xl" }, " Aucun plan mensuel disponible ", -1)
        ]))]))
      : _createCommentVNode("", true),
    _cache[83] || (_cache[83] = _createElementVNode("div", { class: "clear-both h-80" }, null, -1))
  ]))
}
}

})